import "./Loader.css";
import React from "react";
import { useSelector } from "react-redux";

const Loader = () => {
  const loading = useSelector((state) => state.loader.loading);

  if (!loading) return null;

  return (
    <div className="loader">
      <img
        src="https://loading.io/assets/mod/spinner/spinner/lg.gif"
        alt=""
        style={{ width: 450, height: 250 }}
      />
    </div>
  );
};

export default Loader;
